<template>
    <generic-crud :service='service' labelNome='nome_autor'></generic-crud>
</template>
<script>

import GenericCrud from '../components/GenericCrud'
import AuthorsService from '../services/authors-service'

export default {

  components: {
    GenericCrud
  },
  data () {
    return {
      service: AuthorsService
    }
  }

}
</script>

